import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
const Content = [
{
    subTitle: 'Full Packing Services',
    Content: 'When you are planning a move then packing could be the most overwhelming part of your move. You can save your time and get rid of stress by choosing our full-service packing solution. We have a team of professionals that can take care of all your packing needs without worrying about the size and quantity of your belongings.',
    id: 1
},
{
    subTitle: 'Partial Packing Services',
    Content: 'If you only want to move limited stuff of your house, then you can choose our partial packing services. If you want to only move a single room then our team will assess your room and will charge you accordingly.',
    id: 2
},
{
    subTitle: 'Unpacking Services',
    Content: 'When you are moved to a new location then unpacking your possessions could be an incredibly stressful and time-consuming job. We also provide professional unpacking services where we will unpack all your stuff and will place it on your desired location.',
    id: 3
},
{
    subTitle: 'Custom Crating Services',
    Content: 'If there are fragile items to move then they may need some extra care and protection. For this purpose, you can use our custom crating services where will move and load your items on a moving truck with safety and security without any damage.',
    id: 4
},


];
class Packing extends Component{
    render(){
        let title = 'Packing, Unpacking, & Crating';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Packing' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                {/* <div className="rn-page-title-area pt--200 pb--200 bg_image bg_image--17 background-img-packing mt--90"/> */}
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-12 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <Breadcrumb title={'Packing/Unpacking'} />
                                            <h2 className="title">{title}</h2>
                                            <p className="description text-left pt--50"><a href="/">Moonline</a> offers all kinds of packing services from full service packing to customized packing. No matter which service do you choose we are always here to provide you with the best services at most affordable prices.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-center">Types of Packing Services That We Offer</h3>
                                        </div>
                                        {Content.map( (val , i) => (
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">{val.subTitle}</h3>
                                                    <p>{val.Content}</p>
                                                </div>
                                            </div>
                                        </div>
                                        ))}
                                            <div className="row mt--30 text-left">
                                                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                    <div className="about-us-list">
                                                        <h3 className="title">Electronics Packing & Installation</h3>
                                                        <p>If you are moving your office then there are computers, photocopiers and other electronics that need to be handled with extra care. We will pack these items with special care and move them to your desired location. Then we also help you to reinstall your systems to make your move effortless and hassle-free.</p>
                                                        <p>If you are planning a local or long-distance move then you can always trust <a href="/">Moonline</a> for packing and unpacking of your valuable items. We are a licensed and insured company and we provide you complete security and safety of your belongings. We offer our services at most affordable and competitive prices. Our aim is to be your go-to trusted moving partner for all kinds of moving services. To get a free estimate for our packing services you can contact us through our website or <a href="/contact">call us,</a> and one of our moving specialists will assist you in the best possible ways.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Packing;